var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('BaseTableList',{staticClass:"received-table",attrs:{"table-set-list":_vm.setList,"display-items":_vm.filteredItems}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-header"},[_c('h3',[_vm._v("返品商品")])])
}]

export { render, staticRenderFns }